module.exports = __webpack_public_path__ + "static/media/bpls-logo.e4e04bd4.png";